@if (showContent || isAnimating) {
  <!-- Backdrop overlay -->
  <div
    class="fixed inset-0 bg-black/30 z-sidebar-overlay transition-opacity duration-400"
    [class.opacity-0]="!isOpen"
    [class.pointer-events-none]="!isOpen"
    role="button"
    tabindex="0"
    (click)="onBackdropClick()"
    (keydown.escape)="onBackdropClick()"
    (keydown.enter)="onBackdropClick()"
  ></div>

  <!-- Sidebar panel -->
  <aside
    class="fixed top-sidebar-top right-12 bottom-8 bg-white shadow-sidebar z-sidebar-panel flex flex-col gap-8 p-6 rounded-xl md:right-4 md:w-full-mobile pointer-events-auto overflow-hidden"
    [class.slide-in]="isOpen && !isAnimating"
    [class.slide-out]="!isOpen && isAnimating"
    [style.width]="width"
    [style.max-width]="width"
    (click)="onSidebarClick($event)"
    (keydown.escape)="onClose()"
    aria-labelledby="sidebar-title"
    role="dialog"
    tabindex="-1"
  >
    <!-- Header with title and close button -->
    <div class="flex justify-between items-center flex-shrink-0">
      <h3 id="sidebar-title" class="text-2xl font-semibold text-blue-300 m-0">
        {{ title }}
      </h3>
      <button
        type="button"
        class="bg-transparent border-none text-gray-400 text-xl cursor-pointer p-1 flex items-center justify-center transition-colors duration-200 hover:text-gray-500"
        (click)="onClose()"
        aria-label="Cerrar"
      >
        <i class="pi pi-times text-xl"></i>
      </button>
    </div>

    <!-- Content projection with scroll -->
    <div class="flex-1 min-h-0 overflow-y-auto overflow-x-hidden pr-2 -mr-2">
      <ng-content></ng-content>
    </div>
  </aside>
}
